var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCritical2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EF6A3EC1-0DFF-4ADB-8447-A91698A10D31@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.3155556,0 L4.68444444,0 L0,4.68444444 L0,11.3155556 L4.68444444,16 L11.3155556,16 L16,11.3155556 L16,4.68444444 L11.3155556,0 Z M8,13.5 C7.16923077,13.5 6.5,12.8307692 6.5,12 C6.5,11.1692308 7.16923077,10.5 8,10.5 C8.83076923,10.5 9.5,11.1692308 9.5,12 C9.5,12.8307692 8.83076923,13.5 8,13.5 Z M9.125,9 L6.875,9 L6.50227737,3 L9.5,3 L9.125,9 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CondoGo:-Icon-Library",
    transform: "translate(-39.000000, -384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".-\\uD83D\\uDC41-Icons/..-Message/Info-O",
    transform: "translate(39.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/feedback-stop"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-Color",
    fill: "#D02F2F",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical2X);
export default __webpack_public_path__ + "static/media/Critical@2x.3051d7f6b51b5a4bc9364d42bdffa0bf.svg";
export { ForwardRef as ReactComponent };